import * as PropTypes from 'prop-types';
import * as React from 'react';
import { SellCSPPreview } from '@reverbdotcom/discovery-ui';
import ListingAttributes from './listing_attributes';

class ListingAttributesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showAllFields: !props.cspId };
    this.onListingEditClick = this.onListingEditClick.bind(this);
  }

  onListingEditClick() {
    this.toggleForm();
  }

  toggleForm() {
    this.setState({ showAllFields: !this.state.showAllFields });
  }

  renderCSPPreview() {
    if (this.state.showAllFields) { return null; }

    return (
      <div className="mb-4">
        <SellCSPPreview
          cspId={this.props.cspId}
          make={this.props.make}
          model={this.props.model}
          finish={this.props.finish}
          year={this.props.year}
          categories={this.props.categories}
          countryOfOrigin={this.props.countryOfOrigin}
          editForm={this.onListingEditClick}
        />
        {this.renderLinks()}
      </div>
    );
  }

  renderLinks() {
    if (this.state.showAllFields) { return null; }

    return (
      <div className="align-right mt-half size-90">
        {I18n.t('js.listingForm.links.notYourListing')}
        &nbsp;
        <a href="sell/search">
          {I18n.t('js.listingForm.links.searchAgain')}
        </a>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderCSPPreview()}
        <ListingAttributes
          showAllFields={this.state.showAllFields}
          categoriesProps={this.props.categoriesProps}
          countries={this.props.countries}
          canonicalProductProps={this.props.canonicalProductProps}
          values={
            {
              make: this.props.make,
              model: this.props.model,
              finish: this.props.finish,
              year: this.props.year,
              countryOfOrigin: this.props.countryOfOrigin,
              title: this.props.title,
              upc: this.props.upc,
            }
          }
          traits={this.props.traits}
        />
      </React.Fragment>
    );
  }
}

ListingAttributesContainer.propTypes = {
  cspId: PropTypes.number,
  categoriesProps: PropTypes.shape({}).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  make: PropTypes.string,
  model: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string),
  year: PropTypes.string,
  finish: PropTypes.string,
  title: PropTypes.string,
  countryOfOrigin: PropTypes.string,
  upc: PropTypes.string,
  canonicalProductProps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  traits: PropTypes.arrayOf(PropTypes.shape({})),
};

ListingAttributesContainer.defaultProps = {
  make: null,
  model: null,
  categories: [],
  year: null,
  finish: null,
  countryOfOrigin: null,
  title: '',
  cspId: null,
  upc: null,
  canonicalProductProps: [],
};

export default ListingAttributesContainer;



// WEBPACK FOOTER //
// ./src/components/listing_form/listing_attributes_container.jsx